<template>
    <div class="container">
        <div class="main-page"  style="position:relative;">
            <page-header
                :headerConfig="headerConfig"
                @handleClickIocn="handleClickIocn"
            />
            <!-- <page-tops /> -->
            <div class="code-wrap">
                <div class="code">
                    <img src="@/assets/img/code.jpg" alt="" />
                </div>
                <el-button class="sweep" @click="handleScan">扫码入场</el-button>
            </div>

            <div class="out">
                <span>退出登录</span>
            </div>
        </div>
    </div>
</template>

<script>
import pageHeader from "@/components/header";
import pageTops from "./components/jumbotron.vue";

export default {
    name: "staffPage",
    components: {
        pageHeader,
        pageTops,
    },
    data() {
        return {
            headerConfig: {
                headerIcon: "city ct-cuowu",
                headerTitle: "中国土木工程学会",
                color: "#fff",
                bgColor: "#f9000d",
            },
        };
    },
    methods: {
        handleClickIocn() {},
        handleScan() {
            this.$router.push('/scanSuccess')
        }
    },
};
</script>

<style lang="scss" scoped>
.main-page {
    width: 100%;
    height: calc(100vh - 44px);
    padding: 0 15px;
    background: url("~@/assets/img/main-page-bg.jpg") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    overflow: hidden;

    .code-wrap {
        width: 80%;
        margin: 30px auto;
        border-radius: 8px;
        background: #fff;
        overflow: hidden;
        position: absolute;
        bottom: 50px;
        .code {
            width: 40%;
            margin: 30px auto;

            img {
                width: 100%;
            }
        }

        .sweep {
            display: block;
            width: 60%;
            background: var(--main-color);
            margin: 0 auto 30px;
            color: #fff;

            &:focus,
            &:active,
            &:hover {
                border-color: var(--main-color);
            }
        }
    }
    .out {
        position: relative;
        margin-bottom: 40px;
        min-height: 50px;

        span {
            position: absolute;
            bottom: 0;
            right: 0;
            font-weight: bold;
            color: #fff;
        }
    }
}
</style>